import React, {useEffect} from 'react'
import {useTrackVisibility} from 'react-intersection-observer-hook'
import {Playlists} from '../components'
import {PublicPlaylist} from '../components/Playlist'
import {usePagedPlaylists} from '../hooks/usePlaylists'

export const FrontPage = () => {
  const [playlists, {hasMore, loadMore}] = usePagedPlaylists()
  const [ref, {isVisible}] = useTrackVisibility()
  const loadMoreNow = playlists.length && hasMore && isVisible
  const lastIndex = playlists.length - 1

  useEffect(() => {
    if (loadMoreNow) {
      loadMore()
    }
  }, [loadMore, loadMoreNow])

  return (
    <>
      <Playlists>
        {playlists.map((playlist, idx) => {
          const loadMoreItem = idx === lastIndex - 1
          return (
            <PublicPlaylist
              key={playlist.id}
              playlist={playlist}
              size="large"
              ref={loadMoreItem ? ref : undefined}
            />
          )
        })}
      </Playlists>
    </>
  )
}
